import { useCallback } from "react";
import { objectKeys } from "ts-extras";
import { z } from "zod";

import { type Theme, themes } from "~/theme";

import { useAttr } from "./attr";

const [key, ...keys] = objectKeys(themes);
const schema = z.enum([key!, ...keys]).catch("knoword");

export const useTheme = () => {
  const theme = useAttr("data-theme");

  const setTheme = useCallback((value: Theme) => {
    localStorage.setItem("theme", value);
    document.documentElement.setAttribute("data-theme", value);
  }, []);

  return [schema.parse(theme), setTheme] as const;
};
